import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { useSelector, useDispatch } from 'react-redux';
import { userSelector, logout } from './userSlice';

import CircularProgress from '@mui/material/CircularProgress';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

function Logout() {
  const { t } = useTranslation('user');

  const { user } = useSelector(userSelector);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(logout());
  }, []);

  if (user) {
    return (
      <Container sx={{ mt: 5 }}>
        <Box
          sx={{
            mt: 3,
            mb: 3,
            textAlign: 'center',
          }}
        >
          {t('logout_in_progress')}
        </Box>
        <Box
          sx={{
            mt: 3,
            mb: 3,
            textAlign: 'center',
          }}
        >
          <CircularProgress size={'60px'} />
        </Box>
      </Container>
    );
  }

  return <Navigate to="/login" />;
}

export default Logout;
